import { NgModule } from '@angular/core';
import { NgInit } from './ng-init';

@NgModule({
  declarations: [ NgInit ],
  exports: [ NgInit ],
})
export class ContribNgInitModule { }
